import {FC} from 'react';
//mui
import {Box, Divider} from '@mui/material';
//components
import AllSocialItems from './AllSocialItems';
//styles
import {socialFormActionsStyle} from './SocialFormActions.styles';

const SocialFormActions: FC = () => {
	return (
		<Box sx={socialFormActionsStyle.form}>
			<AllSocialItems />

			<Divider sx={socialFormActionsStyle.divider}>or</Divider>
		</Box>
	);
};

export default SocialFormActions;
